import {
    Box,
    Stack,
    Typography,
    CircularProgress,
    FormHelperText,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const UploadBox = ({
    label,
    note,
    value,
    error,
    loading,
    placeholderImage,
    accept = "image/png, image/jpeg",
    height = { xs: 100, md: 120 },
    previewSize = { xs: 200, md: 220 },
    previewSizeProps,
    imageProps,
    onClick,
    onChange,
    onRemove,
    inputRef,
}) => {
    const { t } = useTranslation(["common"]);
    return (
        <>
            {/* Upload Area */}
            <Stack
                justifyContent="center"
                alignItems="center"
                border="1px dashed"
                borderColor={error ? "#d32f2f" : "text.secondary"}
                borderRadius={2}
                sx={{ cursor: "pointer", height, p: 1 }}
                onClick={onClick}
            >
                {loading ? (
                    <CircularProgress size={35} color="inherit" />
                ) : (
                    <img src={placeholderImage} alt="upload" width={100} />
                )}

                <Typography variant="body1" color="text.secondary" mt={1}>
                    {label}
                </Typography>
            </Stack>

            {error && (
                <FormHelperText sx={{ color: "#d32f2f" }}>
                    {t(error)}
                </FormHelperText>
            )}

            {note && (
                <Typography variant="body2" mt={1} fontStyle="italic">
                    {note}
                </Typography>
            )}

           

            <input
                type="file"
                ref={inputRef}
                onChange={onChange}
                style={{ display: "none" }}
                accept={accept}
            />

            {/* Preview */}
            {value && (
                <Box
                    mt={2}
                    borderRadius={2}
                    border="1px solid"
                    borderColor="text.secondary"
                    p={1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    height={previewSize}
                    width={previewSize}
                    position="relative"
                    {...previewSizeProps}
                >
                    <Box
                        component="img"
                        src={value}
                        alt="preview"
                        width="95%"
                        height="95%"
                        sx={{ objectFit: "contain" }}
                        {...imageProps}
                    />

                    <IconButton
                        size="small"
                        onClick={onRemove}
                        sx={{ position: "absolute", top: 2, right: 2 }}
                    >
                        <CloseIcon fontSize="small" htmlColor="red" />
                    </IconButton>
                </Box>
            )}
        </>
    );
};

export default UploadBox;
